// extracted by css-extract-rspack-plugin
export default {"avatar":"V0fmP"};